import RatingRegisterContainer from './RatingRegisterContainer';
export default RatingRegisterContainer;
